<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12" :loading="status.loggingIn">
          <v-toolbar color="blue" dark flat>
            <v-toolbar-title>Fabric Web Portal Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert v-if="computedMessage" data-test-id="message" class="mx-auto" :type="computedAlertType" outlined>
              {{ computedMessage }}
            </v-alert>
            <div v-if="!checkAuth0Client">
              Something went wrong.
              <br />
              Please contact our support team
            </div>
            <div v-if="!$auth.loading">
              <div v-if="$auth.error">
                <div>Error: {{ $auth.error }}</div>
                <div>{{ $auth.errorDescription }}</div>
                <v-btn @click="auth0Logout">Try Again</v-btn>
              </div>
              <div v-else>
                <v-btn v-if="!$auth.isAuthenticated" id="auth0loginBtn" class="button is-dark" @click="auth0Login">
                  Sign in
                </v-btn>
                <v-btn v-else class="button is-dark" @click="auth0Logout">Log out</v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      username: '',
      password: '',
      valid: false,
      status: { loggedIn: false, loggingIn: false },
      computed: { status: '', error: '' },
    };
  },
  computed: {
    computedMessage() {
      return this.$store.state.session.error || this.$store.state.session.status;
    },
    computedAlertType() {
      if (this.status.loggingIn) {
        return 'info';
      }
      if (this.status.loggedIn) {
        return 'success';
      }
      if (this.computed.error) {
        return 'warning';
      }
      return 'success';
    },
    checkAuth0Client() {
      return !!this.$auth.auth0Client;
    },
  },
  mounted() {
    if (this.$store.getters['session/isAuthenticated']) {
      this.$router.replace('/');
    }
  },
  created() {
    this.$store.watch(
      () => this.$store.getters['session/isAuthenticated'],
      (isLoggedIn) => {
        if (isLoggedIn) {
          this.status.loggedIn = true;
          this.$nextTick(() => this.$router.replace('/'));
        }
      }
    );

    this.$store.watch(
      () => this.$store.getters['session/attempt'],
      (attempt) => {
        this.status.loggingIn = attempt;
      }
    );

    this.$store.watch(
      () => this.$store.getters['session/status'],
      (status) => {
        this.computed.status = status;
      }
    );

    this.$store.watch(
      () => this.$store.getters['session/error'],
      (error) => {
        this.computed.error = error;
      }
    );
  },
  methods: {
    handleSubmit(e) {
      if (this.$refs.form.validate()) {
        const { username, password } = this;
        this.$store.dispatch('session/authenticate', { username, password });
        this.status.loggingIn = true;
      }
      e.preventDefault();
    },
    auth0Login() {
      this.$auth.loginWithRedirect();
    },
    auth0Logout() {
      this.$auth.logout();
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  width: 80%;
  margin: 0px auto;
  text-align: center;
}
.loginbox {
  width: 25%;
  height: 40vh;
  margin: 0px auto;
}
.form-group {
  margin-bottom: 5px;

  input {
    width: 95%;
    padding: 14px 5px;
  }
  button {
    width: 100%;
    background-color: #5db2dd;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  button:hover {
    background-color: #75c3ea;
  }
}
.widget {
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 15px;
  border-radius: 5px;
}
</style>
